/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const Logger = require('./Logger');

module.exports = class LoggerFactory {
	static createLogger(name, level) {
		return new Logger({ name, level });
	}
};



// WEBPACK FOOTER //
// ../logger/src/LoggerFactory.js